<template lang="pug" src="./header.pug" />

<script>
import { mapGetters, mapActions } from 'vuex'

const EventBus = window.VueEventBus

const STICKY_HEADER_SCROLL = 700

export default {
    name: 'layout-header',

    props: {
        floating: {
            type: Boolean,
            default: false,
        },
        transparent: {
            type: Boolean,
            default: false,
        },
    },

    data() { return {
        stickyHeader: false,
        showMenu: false,
        showMobileMenu: false,
        elementClickCheckedOnce: false,
        showMobileSearchForm: false,
        unreadCount: null,
    }},

    computed: {
        ...mapGetters(['authUser', 'authCheck']),

        menu() {
            const menu = [
                {
                    icon: 'my-profile-menu',
                    route: 'settings-profile-page',
                    title: "My Profile"
                },
                {
                    icon: 'account-management-menu',
                    route: 'settings-account-management-page',
                    title: "Account Management"
                },
            ]

            if (this.authUser && this.authUser.game_master) {
                menu.push({
                    icon: 'listing-menu',
                    route: 'settings-listing-page',
                    title: 'Listing'
                })
                menu.push({
                    icon: 'payouts-menu',
                    route: 'settings-payouts-page',
                    title: 'Payouts'
                })
            }

            menu.push({
                icon: 'bookings-menu',
                route: 'settings-bookings-page',
                title: 'Bookings'
            })
            menu.push({
                icon: 'reviews-menu',
                route: 'settings-reviews-page',
                title: 'Reviews'
            })
            menu.push({
                icon: 'messages-menu',
                route: 'settings-messages-page',
                title: 'Messages',
                messages: true,
            })

            return menu
        },

        profileImage() {
            return this.authUser.profile_image_md || '/images/client/lairdnd/default-profile-image.png'
        },
        profileImageStyle() {
            return { 'background-image': `url(${this.baseUri}${this.profileImage})` }
        },

        headerClass() {
            return {
                'fixed-top': this.floating && this.stickyHeader,
                'green-bg-color': !this.transparent || this.stickyHeader,
                'static-header': !this.floating,
                'logged-in': this.authCheck,
            }
        },

        showSearchForm() {
            return !this.transparent || this.stickyHeader
        },

        showHeaderMenu() {
            return this.transparent && !this.stickyHeader
        },
    },

    created() {
        const that = this
        document.addEventListener('scroll', function() {
            that.handleHeader()
        })

        this.handleHeader()

        EventBus.$on('lairdnd-messages-read', this.updateUnreadCount)

        this.updateUnreadCount()
    },

    methods: {
        ...mapActions(['logout']),

        handleHeader() {
            if (window.scrollY >= STICKY_HEADER_SCROLL) {
                this.stickyHeader = true
            } else {
                this.stickyHeader = false
            }
        },

        clickOutsideMenu(e) {
            this.showMenu = false
        },

        logout() {
            this.$store.dispatch('logout')
            window.location.reload()
        },

        async updateUnreadCount() {
            if (this.authCheck) {
                const { data: unreadCount } = await axios.get('/api/customer/lairdnd-chat/unread-count')
                this.unreadCount = unreadCount
            }
        },
    }
}
</script>
